import React from 'react';
import './Categories.css';
import { Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';
const Categories = ({ title, categoriesData }) => {
    return (
        <div className="container mb-4 categories-block" id="Categories">
            <h1 className='text-center categories'>{title}</h1>
            <div className="row categories-card-block">
                {
                    categoriesData.map((item, index) => (
                        <div className="card col-md-4 col-sm-6 mt-2 border-0 categories-card" key={index}>
                            <Fade bottom>
                                <Link to={`/categories${item.to}`}>
                                    <img className="card-img-top" src={item.imgSrc} alt="Card cap" />
                                    <div className="card-body">
                                        <h5 className="card-title text-center">{item.title}</h5>
                                    </div>
                                </Link>
                            </Fade>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default Categories;